import { useCallback, useEffect, useMemo } from "react";
import Slider from "react-slick";
import Rating from '@mui/material/Rating';
import { useOrderDetail } from "../../../../store/orderDetail";

import "./styles.scss";

export const Reviews = () => {
  const { getCustomerReviews, reviews } = useOrderDetail();

  useEffect(() => {
    getCustomerReviews();
  }, []);

  const carouselSetting = useMemo(() => ({
    className: "reviews tw-mb-10",
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }), []);

  const renderCarouselItems = useCallback((review) => (
    <div key={review.id} className="review">
      <div className="tw-font-bold">{review.customerName}</div>
      <div>
        <Rating
          name="read-only"
          defaultValue={review.rate}
          readOnly={true}
          size="small"
          sx={{
            "& .MuiRating-iconFilled": {
              color: "#f05623"
            },
          }}
        />
      </div>
      <div className="tw-text-sm">{review.content}</div>
    </div>
  ), [reviews]);


  return (
    <Slider {...carouselSetting}>
      {reviews.map(renderCarouselItems)}
    </Slider>
  );
};
